import { Select, SelectChangeEvent, SelectProps } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { combineSX } from '@/utils/combineSX';
import { DpOutlinedSelectSX } from '@/components/blocks/DpOutlineSelect/styles/main';
import { ReactNode } from 'react';

interface IconComponentProps {
	disabled?: boolean;
}

export const IconComponent = ({ disabled }: IconComponentProps) => (
	<KeyboardArrowDownIcon
		sx={{
			color: disabled ? '#9e9e9e' : '#0467D2',
			position: 'absolute',
			right: '7px',
			top: 'calc(50% - .5em)',
			pointerEvents: 'none',
		}}
	/>
);

export const DpOutlinedSelect: React.FC<
	SelectProps & { onChange?: (event: SelectChangeEvent<unknown>, child: ReactNode) => void }
> = ({ disabled, sx, ...props }) => (
	<Select
		IconComponent={() => <IconComponent disabled={disabled} />}
		disabled={disabled}
		sx={combineSX([DpOutlinedSelectSX, ...(Array.isArray(sx) ? sx : [sx])])}
		{...props}
	/>
);
